import { TransportationType } from '@pflegia/types/common/candidate/transportation-type';

export {
  /** @description Import from @pflegia/types/common instead. */
  TransportationType,
};
